<template>
    <card :noFooterLine="true" class="preview-card" :class="cardType" @click.native="cardClick">

        <div slot="image"  class="preview-card-image" :style="`background-image:url(${image})`">
            <n-button v-if="showBtn" :type="btnClass" class="action-btn" size="sm" @click.native="cardClick">
                <i slot="label" class="now-ui-icons gestures_tap-01"></i> 
                {{ btnText}}
            </n-button>
        </div>

        <div class="preview-card-header">
            <h6 class="card-category" v-if="department">{{ department }}</h6>
            <h6 class="card-category" v-else>&nbsp;</h6>
            <h4 v-if="title" class="card-title">{{ title }}</h4>
            <p v-if="start_date" class="card-description">{{ date }} | {{ venue }}</p>
        </div>

        <div class="preview-card-body">
            <p v-if="start_date && price > 0" class="card-text"><small>Registration Fees:</small> <br><span class="">{{ entryFee }}</span></p>

            <n-progress v-if="(login || isAdmin) && seating" :type="progressClass" :label="`Registration Status [ ${seating.current_seat} / ${seating.max_seat} ]`" :value="Math.round((seating.current_seat/seating.max_seat)*100)" show-value></n-progress>
            <br>
            <p class="bb-line" v-if="open_date && !isOpened"> <small>Registration Starting:</small><br><span class="">{{ openingTime }}</span> </p>
            <p class="bb-line" v-if="close_date && isOpened"> <small>Registration Closing:</small><br><span class="">{{ closingTime }}</span> </p>
        </div>

        <div slot="footer" v-if="showFooter">
            <p class="card-text status-btns">
                <el-tooltip :content="`Price for registration is ${ (price > 0) ? price : 'free'}.`" :open-delay="100" placement="bottom">
                    <n-button :type="`${ (price > 0) ? 'success' : 'default' }`" icon simple round size="sm">
                        ₹
                    </n-button>
                </el-tooltip> 
                <el-tooltip :content="`Authentication is ${ (login) ? 'required' : 'not required'}.`" :open-delay="100" placement="bottom">
                    <n-button :type="`${ (login) ? 'success' : 'default' }`" icon simple round size="sm">
                        <i class="now-ui-icons business_badge"></i>
                    </n-button>
                </el-tooltip>
                <el-tooltip :content="`Visibility is ${ (visible) ? 'true' : 'false'}.`" :open-delay="100" placement="bottom">
                    <n-button :type="`${ (visible) ? 'success' : 'default' }`" icon simple round size="sm">
                        <i class="now-ui-icons business_bulb-63"></i>
                    </n-button>
                </el-tooltip>
                <el-tooltip v-if="type" :content="`Type is ${type}.`" :open-delay="100" placement="bottom">
                    <n-button :type="`${ (type == 'individual') ? 'success' : 'default' }`" icon simple round size="sm">
                        <i v-if="type == 'individual'" class="now-ui-icons users_single-02"></i>
                        <i  v-else class="fa fa-users"></i>
                    </n-button>
                </el-tooltip>
                <el-tooltip v-if="multipleEntry" :content="`Multiple Entry is ${ (multipleEntry) ? 'allowed' : 'not'}.`" :open-delay="100" placement="bottom">
                    <n-button :type="`${ (multipleEntry) ? 'success' : 'default' }`" icon simple round size="sm">
                        <i v-if="type == 'individual'" class="now-ui-icons users_single-02"></i>
                        <i  v-else class="fa fa-users"></i>
                    </n-button>
                </el-tooltip>
            </p>
        </div>
    </card>
</template>

<script>
import { Card, Progress as NProgress, RegistrationProgress as RProgress } from 'src/components'
import {Tooltip} from 'element-ui'

export default {
    name: 'PreviewCard',
    components: {
        Card,
        RProgress,
        NProgress,
        // [RegistrationProgress.name]: RegistrationProgress,
        [Tooltip.name]: Tooltip,
    },
    props: {
        image: String,
        title: String,
        description: String,
        department: String,
        visible: Boolean,
        login: Boolean,
        multipleEntry: Boolean,
        seating: Object,
        slug: String,
        venue: String,
        type: String,
        eventType: String,
        open_date: String,
        close_date: String,
        start_date: String,
        end_date: String,
        entity: String,
        price: Number,
        showFooter: {
            type: Boolean,
            default: false,
        },
        cardType: String,
        isOpen: {
            type: Boolean,
            default: false,
        },
        showBtn: {
            default: true,
            type: Boolean
        }
    },
    computed: {
        entryFee: function (){
            return (this.price > 0) ? `₹ ${this.price}` : `Free Entry`;
        },
        date: function(){
            let date = new Date(this.start_date);
            return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        },
        openingTime: function(){
            let date = new Date(this.open_date);
            return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        },
        closingTime: function(){
            let date = new Date(this.close_date);
            return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        },
        isOpened: function(){
            let now = new Date();
            if(!this.open_date) return false;
            let openTime = new Date(this.open_date);
            return (now > openTime) ? true : false;
            // return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        },
        isClosed: function(){
            let now = new Date();
            if(!this.close_date) return false;
            let closeTime = new Date(this.close_date);
            return (now > closeTime) ? true : false;
            // return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        },
        remainingSeats: function(){
            return (this.seating.max_seat - this.seating.current_seat)
        },
        progressClass: function () { 
            let percent = Math.round((this.seating.current_seat/this.seating.max_seat)*100)
            if(percent <= 75){
                return 'success'
            }
            else if(percent <= 99){
                return 'warning'
            }
            else{
                return 'danger'
            }
         },
        btnClass: function(){
            if(this.isOpen){
                if(this.seating.current_seat < this.seating.max_seat){
                    return 'success'
                }
                else{
                    return 'danger'
                }
            }   
            else{
                return 'primary'
            }
        },
        btnText: function(){
            if(this.isOpen){
                if(this.seating.current_seat < this.seating.max_seat){
                    return 'Register Now'
                }
                else{
                    return 'All Seats Filled'
                }
            }   
            else{
                return 'View Details'
            }
        },
        isAdmin(){
            return (this.$currentUser) ? this.$currentUser.roles.includes('admin') : false
        },
    },
    methods: {
        cardClick(){
            this.$emit('card-click', this.slug)
        }
    }
}
</script>

<style lang="scss">

/* Using plain CSS */
@media (max-width: 768px) {
    .preview-card.long{
        flex-direction: column !important;

        .card-body::after{
            display: none !important;
        }

        .action-btn{
            right: 0px !important;
            bottom: 160px !important;
            font-size: 14px !important;
            padding: 5px 10px !important;
        }
    }
}

.preview-card{
    
    &.long{
        display: flex;
        flex-direction: row;
        cursor: pointer;
        border-radius: 0.1875rem;
        overflow: hidden;

        .card-image{
            flex: 2;
            transition: all ease-in-out 0.3s;

            .preview-card-image{
                position: static;
                .action-btn{
                    z-index: 3;
                    right: 10px;
                    bottom: 0px;

                    font-size: 16px;
                    border-radius: 0.1875rem;
                    padding: 10px 15px;
                }
            }
        }

        .card-header,
        .card-body,
        .card-footer{
            flex: 2;
        }

        .card-body{
            padding: 15px;
            padding-left: 30px;
            position: relative;
            transition: all ease-in-out 0.3s;
            z-index: 2;

            &::after{
                content: '';
                position: absolute;
                height: 100%;
                width: 50px;
                background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
                top: 0;
                left: -50px;
                transition: all ease-in-out 0.3s;
                z-index: 1;
            }
        }

        &:hover > .card-body{
            padding-left: 30px;
        }

        &:hover > .card-body::after{
            // flex: 1.2;
            left: -30px;
        }

        // &:hover > .card-image{
        //     flex: 1.2;
        // }

    }

    .preview-card-header{
        .card-title{
            margin-top: 0px;
            margin-bottom: 5px;
        }
    }

    .card-footer .status-btns .btn{
        margin-right: 3px;
    }

    .card-header .card-title{
        margin-top: 5px;
        margin-bottom: 0.5rem;
    }

    .category, .card-category{
        margin-bottom: 0.2em;
    }

    .card-body{
        padding: 5px 15px 15px 15px;
    }

    .progress-container .progress-badge{
        text-transform: initial;
    }

    .description, 
    .card-description, 
    .footer-big p, 
    .footer .stats{
        color: #353a3e;
    }

    .card-image{
        .preview-card-image{
            height: 100%;
            min-height: 250px;
            position: relative;
            text-align: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            box-shadow: inset -1px -5px 5px -3px rgba(0, 0, 0, 0.16);

            .action-btn{
                right: -20px;
                bottom: -25px;
                position: absolute;
                box-shadow: 0px 2px 3px rgba(0,0,0,0.16);
            }

            .card-img-top{
                width: auto;
                height: 200px;
                margin: 0 auto;
                text-align: center;
            }
        }
    }

} 

</style>
